import { Images } from "@/constants/images"
import { CustomerFieldConfig, ReceiveSMS } from "@/types/types"

// ==================== Customer Constants ====================

// Constants cho Receive SMS options
export const RECEIVE_SMS_OPTIONS = [
  { label: "no", value: ReceiveSMS.NO },
  { label: "cz", value: ReceiveSMS.CS },
  { label: "vn", value: ReceiveSMS.VN },
  { label: "en", value: ReceiveSMS.EN },
]

// Constants cho Yes/No Radio options
export const YES_NO_RADIO_OPTIONS = [
  { label: "No", value: false },
  { label: "Yes", value: true },
]

// Customer Form Fields Configuration
export const CUSTOMER_FIELDS_CONFIG: CustomerFieldConfig[] = [
  // Left Column
  {
    name: "ico",
    labelKey: "Ico",
    type: "input",
    column: "left",
  },
  {
    name: "businessName",
    labelKey: "Business Name",
    type: "input",
    column: "left",
  },
  {
    name: "phone",
    labelKey: "Phone",
    type: "input",
    rules: [{ required: true, message: "Please input phone number!" }],
    column: "left",
  },
  {
    name: "email",
    labelKey: "Email",
    type: "input",
    rules: [
      { required: true, message: "Please input email!" },
      { type: "email", message: "Please enter a valid email!" },
    ],
    column: "left",
  },
  {
    name: "address",
    labelKey: "Address",
    type: "input",
    column: "left",
  },
  {
    name: "city",
    labelKey: "City",
    type: "input",
    column: "left",
  },
  {
    name: "receiveAtSore",
    labelKey: "Receive At Store",
    type: "input",
    column: "left",
  },
  {
    name: "receiveSMS",
    labelKey: "Receive SMS",
    type: "select",
    initialValue: ReceiveSMS.NO,
    options: RECEIVE_SMS_OPTIONS,
    column: "left",
  },
  {
    name: "idNumber",
    labelKey: "Id Number",
    type: "input",
    column: "left",
  },
  {
    name: "fullname",
    labelKey: "Fullname",
    type: "input",
    column: "left",
  },
  {
    name: "birthNumber",
    labelKey: "Birth Number",
    type: "input",
    column: "left",
  },

  // Right Column
  {
    name: "dic",
    labelKey: "Dic",
    type: "input",
    column: "right",
  },
  {
    name: "businessRepresentative",
    labelKey: "Business Representative",
    type: "input",
    column: "right",
  },
  {
    name: "dphRegistered",
    labelKey: "Dph Registered",
    type: "radio",
    initialValue: false,
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
  {
    name: "countryOrState",
    labelKey: "Country or State",
    type: "input",
    column: "right",
  },
  {
    name: "haveVAT",
    labelKey: "Have VAT",
    type: "radio",
    initialValue: false,
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
  {
    name: "signature",
    labelKey: "Signature",
    type: "input",
    placeholder: "Signature ID or URL",
    column: "right",
  },
  {
    name: "occupation",
    labelKey: "Occupation",
    type: "input",
    column: "right",
  },
  {
    name: "registrationCode",
    labelKey: "Registration Code",
    type: "input",
    column: "right",
  },
  {
    name: "isSentEmail",
    labelKey: "Is Sent Email",
    type: "radio",
    initialValue: false,
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
  {
    name: "isResolved",
    labelKey: "Is Resolved",
    type: "radio",
    initialValue: false,
    options: YES_NO_RADIO_OPTIONS,
    column: "right",
  },
]

// Helper functions to get fields by column
export const getLeftColumnFields = () => CUSTOMER_FIELDS_CONFIG.filter(field => field.column === "left")

export const getRightColumnFields = () => CUSTOMER_FIELDS_CONFIG.filter(field => field.column === "right")

// ==================== Header Constants ====================
export const HEADER_SLOGAN = "VÌ MỘT CỘNG ĐỒNG NGƯỜI VIỆT HỘI NHẬP VÀ PHÁT TRIỂN TẠI CHÂU ÂU"

export const DAYS_KEYS = [
  "days.sunday",
  "days.monday",
  "days.tuesday",
  "days.wednesday",
  "days.thursday",
  "days.friday",
  "days.saturday",
]

export const MONTHS_KEYS = [
  "months.january",
  "months.february",
  "months.march",
  "months.april",
  "months.may",
  "months.june",
  "months.july",
  "months.august",
  "months.september",
  "months.october",
  "months.november",
  "months.december",
]

// ==================== Post Category Constants ====================
// Page size cho posts category
export const POST_CATEGORY_PAGE_SIZE = 20
export const FEATURED_POST_COUNT = 1
export const SUB_FEATURE_POSTS_COUNT = 3
export const SIDE_POSTS_COUNT = 5
export const FIRST_PAGE_SPECIAL_POSTS = FEATURED_POST_COUNT + SUB_FEATURE_POSTS_COUNT + SIDE_POSTS_COUNT
export const PAGINATION_PAGE_SIZE = POST_CATEGORY_PAGE_SIZE - FIRST_PAGE_SPECIAL_POSTS

// =================================================================

export const RELATED_POSTS_PAGE_SIZE = "10"
export const RELATED_POSTS_SORT = "publishedAt:desc"
export const RELATED_POSTS_DEFAULT_LOCALE = "vi"

export const SIDEBAR_POSTS_DEFAULT_PAGE_SIZE = "10"
export const SIDEBAR_POSTS_SORT = "publishedAt:desc"
export const SIDEBAR_POSTS_DEFAULT_LOCALE = "vi"

// "Tin nổi bật" trên site tamdamedia lấy từ một danh mục "Nổi bật" cố định
// (khớp prod: `APP_CONFIG.MEDIA.FEATURED_CATEGORY = "67"`), giống nhau trên mọi
// bài. Site tamdagroup KHÔNG dùng hằng số này — nó lấy bài cùng chuyên mục với
// bài đang đọc (logic động). Nếu id danh mục nổi bật của media thay đổi, sửa ở đây.
export const FEATURED_POSTS_CATEGORY_ID_TAMDAMEDIA = "67"

export const SIDEBAR_PAGE_SIZE_TAMDA_MEDIA = "10"
export const SIDEBAR_PAGE_SIZE_TAMDA_ONE = "20"
export const SIDEBAR_PAGE_SIZE_DEFAULT = "10"

export const BANNER_VALID_POSITIONS = ["sidebar"]
export const BANNER_PAGE_NEWS_DETAIL = "NEWS_DETAIL"
export const BANNER_FETCH_PAGE_SIZE = "10"

export const POST_DETAIL_DEFAULT_AUTHOR = "Hà Giang"
export const POST_DETAIL_DEFAULT_HAS_BREADCRUMB = true

export type SupportedLocale = "vi" | "en" | "cs"

export const SUPPORTED_LOCALES = [
  { value: "vi", label: "Tiếng Việt", icon: Images.logoVi },
  { value: "en", label: "English", icon: Images.logoEn },
  { value: "cs", label: "Čeština", icon: Images.logoCs },
]

// Base URL canonical/og:url — luôn là domain PRODUCTION, kể cả khi build đang
// chạy trên staging (dev./media.). Staging không nên tự chỉ định canonical về
// chính nó, tránh bị index.
export const SITE_URLS: Record<string, string> = {
  "tamdamedia.eu": "https://tamdamedia.eu",
  "tamdagroup.eu": "https://tamdagroup.eu",
}

// Tên hiển thị mặc định của từng site — dùng cho SEO/OG khi Strapi settings chưa
// có websiteName/description. KHÔNG trộn lẫn 2 cụm: share bài bên tamdamedia
// không được lòi ra "TAMDA GROUP" và ngược lại.
export const SITE_META_DEFAULTS: Record<string, { name: string; description: string; keywords: string }> = {
  "tamdamedia.eu": {
    name: "TamdaMedia",
    description: "TamdaMedia",
    keywords: "TamdaMedia",
  },
  "tamdagroup.eu": {
    name: "Tamda Group",
    description: "Tamda Group",
    keywords: "Tamda Group",
  },
}

// BẠN CŨNG CÓ THỂ ĐỊA NGHĨA DEFAULT IMAGE TẠI ĐÂY
export const DEFAULT_META_IMAGE = "https://d300nzfp1n1jsy.cloudfront.net/photo_2023_07_01_11_26_54_0cd5ebe5f5.webp"

// Banner hero mặc định dùng chung khi danh mục chưa gán banner (áp dụng cụm tamdaone).
export const DEFAULT_HERO_BANNER = "https://d300nzfp1n1jsy.cloudfront.net/photo_2023_07_01_11_26_54_0cd5ebe5f5.webp"

export const STRAPI_BLUE = "#4945ff"
export const STRAPI_ICON_BG = "#e8e8ff"
